(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const THRESHOLD = 2000; // Free shipping threshold in PHP

    function formatPHP(amount) {
      return '₱' + amount.toLocaleString();
    }

    function renderProgress(cartTotal) {
      const container = document.querySelector('.' + 'free-shipping-container');
      const textEl = document.getElementById('free-shipping-text');
      const barEl = document.getElementById('free-shipping-bar');

      // If container missing, stop — prevents errors
      if (!container || !textEl || !barEl) return;

      // Hide container when cart is empty
      if (cartTotal <= 0) {
        container.style.display = 'none';
        return;
      }

      // Show container when cart has items
      container.style.display = '';

      const progressPercent = Math.min((cartTotal / THRESHOLD) * 100, 100);
      barEl.style.width = progressPercent + '%';

      if (cartTotal >= THRESHOLD) {
        textEl.textContent = '⛟ Congratulations! You get free shipping.';
      } else {
        const remaining = THRESHOLD - cartTotal;
        textEl.innerHTML = `⛟ Spend <strong>${formatPHP(remaining)}</strong> more to get free shipping.`;
      }
    }

    async function getCartTotal() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed to fetch cart');
        const cart = await res.json();

        const totalCents =
          typeof cart.total_price !== 'undefined'
            ? cart.total_price
            : typeof cart.items_subtotal_price !== 'undefined'
            ? cart.items_subtotal_price
            : 0;
        return Math.round(totalCents / 100);
      } catch (err) {
        console.error('Free shipping script error:', err);
        return 0;
      }
    }

    let updateTimeout = null;
    function scheduleUpdate(delay = 50) {
      if (updateTimeout) clearTimeout(updateTimeout);
      updateTimeout = setTimeout(async () => {
        updateTimeout = null;
        const total = await getCartTotal();
        renderProgress(total);
      }, delay);
    }

    // Init
    document.addEventListener('DOMContentLoaded', () => scheduleUpdate(0));
    document.addEventListener('cart:updated', () => scheduleUpdate(50));
    document.addEventListener('cart:refresh', () => scheduleUpdate(50));
    document.addEventListener('cart:change', () => scheduleUpdate(50));

    // Observe drawer for changes (some themes don't fire events)
    const drawerSelectorCandidates = ['.cart-drawer', '#CartDrawer', '#drawer-cart', '.minicart'];
    const drawerEl = drawerSelectorCandidates.map((s) => document.querySelector(s)).find((el) => el);

    if (drawerEl) {
      const mo = new MutationObserver(() => scheduleUpdate(50));
      mo.observe(drawerEl, { childList: true, subtree: true, attributes: true });
    }

    // Manual refresh for debugging
    window._KOMO_freeShippingRefresh = () => scheduleUpdate(0);
  })();
  } catch(e) { console.error(e); }
})();

})();
